<section class="login-background">
  <app-pattern></app-pattern>
  <mat-card appearance="outlined" class="login-card">
    <app-loader [loading]="!utilService.translationsLoaded" [size]="32"></app-loader>
    <div *ngIf="utilService.translationsLoaded">
      <app-compact-header></app-compact-header>
      <div class="heading-5">{{'general.api_change_password_title' | translate}}</div>
      <form #loginForm="ngForm" class="flex flex-column" (ngSubmit)="submit()" autocomplete="off">
        <mat-form-field appearance="outline" class="no-hint">
          <mat-label>{{'general.api_change_password_old' | translate}}</mat-label>
          <input matInput type="password" name="oldPassword" id="oldPassword" [(ngModel)]="oldPassword" required autocomplete="off">
        </mat-form-field>
        <mat-form-field appearance="outline" [ngClass]="{'no-hint': !newPassword || validPassword, 'responsive-hint field-error': newPassword && !validPassword}">
          <mat-label>{{'general.api_change_password_new' | translate}}</mat-label>
          <input matInput type="password" name="newPassword" id="newPassword" [(ngModel)]="newPassword" required autocomplete="off">
          <mat-hint *ngIf="newPassword && !validPassword" class="text-warning format-pre-line">{{'general.api_general_password_hint' | translate}}</mat-hint>
        </mat-form-field>
        <mat-form-field appearance="outline" [ngClass]="{'no-hint': !newPasswordRepeat || passwordsMatch, 'field-error': newPasswordRepeat && !passwordsMatch}">
          <mat-label>{{'general.api_change_password_new_repeat' | translate}}</mat-label>
          <input matInput type="password" name="newPasswordRepeat" id="newPasswordRepeat" [(ngModel)]="newPasswordRepeat" required autocomplete="off">
          <mat-hint *ngIf="newPasswordRepeat && !passwordsMatch" class="text-warning format-pre-line">{{'general.api_general_passwords_should_match' | translate}}</mat-hint>
        </mat-form-field>
        <button mat-flat-button color="primary" type="submit" [disabled]="!loginForm.form.valid || !checkPassword || isLoading">
          <mat-spinner [diameter]="24" color="accent" *ngIf="isLoading"></mat-spinner>
          <ng-container *ngIf="!isLoading">{{'general.api_change_password_submit' | translate}}</ng-container>
        </button>
        <button type="button" mat-button (click)="goBack()">
          {{'general.api_change_password_cancel' | translate}}
        </button>
      </form>
    </div>
    <div class="align-center version">
      {{ viewService.version }}<ng-container *ngIf="!!viewService.conf.environment"> | {{ viewService.conf.environment }}</ng-container>
    </div>
  </mat-card>
</section>
